(() => {
  // Carry campaign attribution through catalogue links without cookies or storage.
  const source = new URLSearchParams(window.location.search);
  const campaign = ['utm_source', 'utm_medium', 'utm_campaign'].filter(key => source.get(key));
  if (!campaign.length) return;
  function decorate(link) {
    if (!link || !link.getAttribute('href') || link.getAttribute('href').startsWith('#')) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !/^\/(?:$|products\/|collections(?:\/|$)|pages\/)/.test(url.pathname)) return;
    if (url.pathname === '/pages/data-sharing-opt-out') return;
    campaign.forEach(key => { if (!url.searchParams.has(key)) url.searchParams.set(key, source.get(key).slice(0, 150)); });
    link.href = url.href;
  }
  document.addEventListener('click', event => decorate(event.target.closest?.('a[href]')), true);
  document.addEventListener('auxclick', event => decorate(event.target.closest?.('a[href]')), true);
  const init = () => document.querySelectorAll('a[href]').forEach(decorate);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
